import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { NotificationService } from '@core/services/notification.service';
import { UiService } from '@core/services/ui.service';

@Component({
  selector: 'gt-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage {
  public hidePasswordLogin = true;
  public isLoginSubmitted = false;
  public loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  redirect = this.route.snapshot.queryParams['redirect'];

  constructor(
    private authService: AuthService,
    private ui: UiService,
    private fcmService: NotificationService,
    public location: Location,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  doLogin() {
    if (this.loginForm.valid && this.loginForm.value.email && this.loginForm.value.password) {
      this.authService
        .login(this.loginForm.value.email, this.loginForm.value.password)
        .then(() => {
          this.fcmService.initPush();
          if (this.redirect) {
            this.router.navigate(['/onboarding/register/form']);
          } else {
            this.location.back();
          }
        })
        .catch((error) => {
          this.ui.showToast(this.getAuthErrorLabel(error.code), 'danger', 6_000);
        });
    }
  }

  private getAuthErrorLabel(error: string) {
    let errorLabel = '';
    switch (error) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
      case 'auth/invalid-login-credentials':
        errorLabel = 'LOGIN_FAILED';
        break;
      case 'auth/invalid-email':
        errorLabel = 'LOGIN_EMAIL';
        break;
      case 'auth/invalid-password':
        errorLabel = 'LOGIN_PASSWORD';
        break;
      case 'auth/email-already-exists':
      case 'auth/email-already-in-use':
        errorLabel = 'REGISTER_EXISTS';
        break;
      case 'auth/too-many-requests':
        errorLabel = 'TOO_MANY_REQ';
        break;
      case 'auth/user-disabled':
        errorLabel = 'USER_DISABLED';
        break;
      case 'auth/account-exists-with-different-credential':
        errorLabel = 'EXISTS_CREDENTIAL';
        break;
      case 'auth/popup-closed-by-user':
        errorLabel = 'POPUP_CLOSED';
        break;
      case 'auth/internal-error':
      default:
        errorLabel = 'UNKNOWN_ERROR';
        break;
    }
    return 'ONBOARDING.ERROR.' + errorLabel;
  }
}
